import React from "react";

import Header from "./components/Header";
import Hero from "./components/Hero";
import ImpactBar from "./components/ImpactBar";
import About from "./components/About";
import KemkianEcole from "./components/KemkianEcole";
import KemkianGallery from "./components/KemkianGallery";
import ModeleEcole from "./components/ModeleEcole";
import ModeleGallery from "./components/ModeleGallery";
import Events from "./components/Events";
import Partners from "./components/Partners";
import Donate from "./components/Donate";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App = () => {
  return (
    <div className="max-w-[1920px] mx-auto overflow-hidden bg-white">
      <Header />
      <Hero />
      <ImpactBar />
      <About />
      <KemkianEcole />
      <KemkianGallery />
      <ModeleEcole />
      <ModeleGallery />
      <Events />
      <Partners />
      <Donate />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
